import React from 'react';
import { textEllipsis } from '../../../shared/utils/constants';

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.name'),
      field: 'fullName',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { fullName } = rowData;
        return (
          <span className="tooltip-test" title={fullName}>
            {fullName}
          </span>
        );
      },
    },
    { title: t('general.gender'), field: 'gender' },
    {
      title: t('general.phones'),
      field: 'phones',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { phones } = rowData;
        return (
          <span className="tooltip-test" title={phones}>
            {phones}
          </span>
        );
      },
    },
    { title: t('general.date-of-birth'), field: 'formattedDateOfBirth' },
    {
      title: t('general.classes-names'),
      field: 'classesNames',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { classesNames } = rowData;
        return (
          <span className="tooltip-test" title={classesNames}>
            {classesNames}
          </span>
        );
      },
    },
    { title: t('general.agreement'), field: 'studentOrigin.label' },
    { title: t('general.active'), field: 'activeDescription' },
  ];
}
